module.exports = __webpack_public_path__ + "media/images/flags/64/Turkey-a3070aaf8414441f91e7e5d6607747c5.png";